import styled from "styled-components";
import { device } from "../utils";

const Wrapper
	= styled.div`
		position: relative;
		background-color: #222;
		margin-top: calc(30px + 3vw);
		box-shadow: 0 -5px 15px rgba(0,0,0,.6);

		.inner-wrapper {
			@media ${device.mobileP} {
				justify-content: center;
				flex-direction: column;
				gap: calc(5px + .5vw);
				padding: calc(8px + .8vw);
				padding: calc(16px + .8vw) calc(4px + .4vw);
			}
			@media ${device.mobilePUp} {
				justify-content: space-between;
				padding: calc(8px + .8vw);
			}

			display: flex;
			align-items: center;
			padding: 0;

			.links-list {
				display: flex;
				gap: calc(8px + .8vw);
				margin: 0 calc(-3px - .3vw);
			}

			.copyright {
				color: white;
				font-weight: 600;
			}
		}
	`

export default Wrapper
